/* ============================================================
   Office hover reveal (.office-row) — Contact section
   ------------------------------------------------------------
   The first office row is open by default; hovering another row
   opens it and closes the rest. Hover-triggered — NOT a click
   accordion (see accordion.js for the click-to-toggle pattern
   used by Software Types / FAQ). Mirrors contact.css/.office-row.
   ============================================================ */
export function initOfficeHoverReveal() {
  var officeRows = document.querySelectorAll(".office-row");
  if (!officeRows.length) return;

  function openRow(row) {
    officeRows.forEach(function (item) {
      var content = item.querySelector(".accordion-content-wrapper");
      if (content) {
        item.classList.remove("active");
        content.style.maxHeight = null;
      }
    });

    var content = row.querySelector(".accordion-content-wrapper");
    if (content) {
      row.classList.add("active");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }

  openRow(officeRows[0]);

  officeRows.forEach(function (row) {
    if (!row.querySelector(".accordion-content-wrapper")) return;
    row.addEventListener("mouseenter", function () {
      openRow(row);
    });
  });
}
